/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".gva-icon[_ngcontent-%COMP%]{width:60px;height:60px;font-size:60px}.remaining-space[_ngcontent-%COMP%]{flex:1 1 auto}mat-icon[_ngcontent-%COMP%]{width:40px;height:40px;font-size:40px}button[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{width:25px;height:25px;font-size:25px}"];
export { styles as styles };
